const YankeePolkaFollow = {
    name: "Yankee Polka",
    bpm: 120,
    signature: "4/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default YankeePolkaFollow;